
export default [{
	path: '/warehouses-movements',
	component: () => import('@/components/warehouses-movements/List')
}]
